var Alignment = /* @__PURE__ */ ((Alignment2) => {
  Alignment2["start"] = "start";
  Alignment2["end"] = "end";
  Alignment2["flexStart"] = "flex-start";
  Alignment2["flexEnd"] = "flex-end";
  Alignment2["center"] = "center";
  Alignment2["left"] = "left";
  Alignment2["right"] = "right";
  Alignment2["normal"] = "normal";
  Alignment2["spaceBetween"] = "space-between";
  Alignment2["spaceAround"] = "space-around";
  Alignment2["spaceEvenly"] = "space-evenly";
  Alignment2["stretch"] = "stretch";
  Alignment2["safe"] = "safe";
  Alignment2["unsafe"] = "unsafe";
  return Alignment2;
})(Alignment || {});
export {
  Alignment
};
//# sourceMappingURL=alignment.es.js.map
